import { ChangeEvent, ReactNode } from "react"
import { FormControl } from "../../../components/form/FormControl"
import { useIsMaxMd } from "../../../hooks/mediaHooks"
import { fontVariants, styled, theme } from "../../../styles/stitches.config"

const InputLabel = styled("span", {
  ...fontVariants.textsLarge,

  display: "flex",
  alignItems: "center",
  height: "100%",
})

interface Props {
  inputLabel: ReactNode
  valueLabel: string
  value?: number
  onChange?: (value?: number) => void
}

export const ValueInput = ({ inputLabel, valueLabel, onChange, value }: Props) => {
  const isMedium = useIsMaxMd()

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const formValue = Number.parseFloat(e.currentTarget.value)
    onChange?.(Number.isNaN(formValue) ? undefined : formValue)
  }

  return (
    <FormControl
      label={inputLabel}
      rightContent={<InputLabel>{valueLabel}</InputLabel>}
      css={!isMedium ? { maxWidth: theme.sizes.s40 } : {}}
    >
      <input type="number" step="0.01" value={value ?? ""} onChange={handleChange} />
    </FormControl>
  )
}
